import { cva } from "class-variance-authority";
import { cn } from "../../../client/cn";

export type SurfaceCardPadding = "none" | "sm" | "md" | "lg";
export type SurfaceCardLayout = "default" | "stack" | "split";

export interface SurfaceCardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: SurfaceCardPadding;
  layout?: SurfaceCardLayout;
  elevated?: boolean;
}

const surfaceCardVariants = cva(
  "rounded-xs border border-stroke bg-white dark:border-strokedark dark:bg-boxdark",
  {
    variants: {
      padding: {
        none: "",
        sm: "p-4",
        md: "p-6",
        lg: "px-5 pt-6 pb-2.5 sm:px-7.5 xl:pb-1",
      },
      layout: {
        default: "",
        stack: "flex flex-col gap-4",
        split: "flex items-start justify-between gap-4",
      },
      elevated: {
        true: "shadow-default",
        false: "",
      },
    },
    defaultVariants: {
      padding: "md",
      layout: "default",
      elevated: true,
    },
  },
);

export function SurfaceCard({
  padding = "md",
  layout = "default",
  elevated = true,
  className = "",
  ...props
}: SurfaceCardProps) {
  return (
    <div
      {...props}
      className={cn(
        surfaceCardVariants({ padding, layout, elevated }),
        className,
      )}
    />
  );
}
